var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrderHistoryActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.761 3.949H0v-1.5h12.761ZM6.432 15.456H0v-1.5h6.432ZM8.1 9.703H0v-1.5h8.1ZM6.432 21.209H0v-1.5h6.432Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFC72C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.497 20.799H10.081a.71.71 0 0 1-.749-.743l1.317-11.994a.726.726 0 0 1 .749-.609h9.781a.726.726 0 0 1 .749.609l1.317 11.994a.71.71 0 0 1-.748.743"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.497 21.549H10.081a1.53 1.53 0 0 1-1.145-.5 1.39 1.39 0 0 1-.349-1.073L9.904 7.982a1.47 1.47 0 0 1 1.494-1.277h9.781a1.47 1.47 0 0 1 1.494 1.278l1.317 11.993a1.39 1.39 0 0 1-.349 1.073 1.53 1.53 0 0 1-1.144.5m-12.409-1.5h12.4l-1.3-11.846h-9.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.084 9.953a2 2 0 0 1-.072-.4c-.722-5.19-2.031-5.606-2.427-5.606h-.007c-.668.008-1.323.993-1.8 2.7a19 19 0 0 0-.552 3.122l-1.5-.115a20 20 0 0 1 .6-3.388 8.5 8.5 0 0 1 1.04-2.457 2.66 2.66 0 0 1 2.189-1.364h.03c1.325 0 2.362 1.063 3.084 3.161a21 21 0 0 1 .824 3.738l.029.2a1 1 0 0 0-.021-.077Z"
}))));
export { SvgOrderHistoryActive as ReactComponent };
export default "/_next/static/images/order_history-active.svg";